export * from "-!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./header.vue?vue&type=template&id=29e8c3c6&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/header.vue?vue&type=template&id=29e8c3c6&scoped=true&
// module id = null
// module chunks = 